import { RecruitmentCaregiverApplicationQuestionId } from "./ObjectIds";
import { TranslationMapping } from "./Video";

export interface PossibleAnswer {
  id: PossibleAnswerId;
  text: string;
}

export type PossibleAnswerId = number;

export type RecruitmentQuestionLanguages = TranslationMapping<string>;

export type RecruitmentPossibleAnswersLanguages = TranslationMapping<PossibleAnswer[]>;

export type CaregiverRecruitmentAnswer = string | number | number[] | null;

export interface CaregiverRecruitmentQuestionAnswer {
  answer: CaregiverRecruitmentAnswer;
}

export interface CaregiverRecruitmentData {
  showApplication: boolean;
  applicationData: RecruitmentQuestionData[] | null;
}

export interface CaregiverRecruitmentShowStatus {
  showApplication: boolean;
}

export const DEFAULT_TRANSLATION_LANGUAGE = "English";

export type RecruitmentQuestionType =
  | "Text"
  | "Email" // need to see if it's being used
  | "Numeric"
  | "FullDate"
  | "MonthYearDate"
  | "Radio"
  | "Checkbox"
  | "Signature"
  | "Document"
  | "TitleText"
  | "LongText";

export interface RecruitmentQuestionData {
  id: RecruitmentCaregiverApplicationQuestionId;
  order: number;
  questionText: RecruitmentQuestionLanguages;
  possibleAnswers: RecruitmentPossibleAnswersLanguages | null;
  parentId: RecruitmentCaregiverApplicationQuestionId | null;
  parentAnswer: number | null;
  isMandatory: boolean;
  answer: string | number | number[] | null;
  type: RecruitmentQuestionType;
}

export interface RecruitmentUploadDocUrl {
  url: string;
}

export interface RecruitmentUploadDoc {
  base64: string;
}
